import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "src/app/components/Button/Button";
import { DropdownMenu } from "src/app/components/Dropdown/Dropdown";
import { useHistory } from "react-router";
import { AppLocation } from "src/redux/main/mainReducer";
import { RootState } from "src/redux/reducers";
import { WsExtension, ExtensionTypeEnum } from "src/types";
import { ReactComponent as LightningIcon } from "../../../images/lightning.svg";
import { CreatorDatabaseConfigurationSection } from "../../SettingsModal/tabs/CreatorDatabaseConfiguration/CreatorDatabaseConfiguration";
import { openSettingsModal } from "../../SettingsModal/methods";
import { SettingsContext, SettingsTab } from "../../SettingsModal/enums";
import IDHFormattedMessage from "../IDHFormattedMessage/IDHFormattedMessage";
import DropdownPortal from "../DropdownPortal";
import "src/app/dropdowns/ExtensionsDropdown/ExtensionsDropdown.scss";

export default function CreatorDatabaseExtensionDropdown() {
  const {
    mainReducer: {
      identity: { wsWorkspaceExtensions },
    },
  } = useSelector((state: RootState) => state);
  const history = useHistory();
  const [visible, setVisible] = useState(false);

  const allowedExtensionTypesToCount = [
    ExtensionTypeEnum.CreatorDatabaseSubmissionForm,
    ExtensionTypeEnum.ApiConnection,
  ];

  const numberOfEnabledWorkspaceExtensions = wsWorkspaceExtensions?.filter(
    (e) => e?.enabled && allowedExtensionTypesToCount.includes(e?.type),
  );

  if (!numberOfEnabledWorkspaceExtensions?.length) return null;

  const openExtensions = (section: string) => {
    setVisible(false);

    openSettingsModal(
      history,
      AppLocation.Navbar,
      SettingsContext.Workspace,
      SettingsTab.CreatorDatabaseConfiguration,
      section,
    );
  };

  const renderExtensionsListOptions = (
    extensionList: WsExtension[] | undefined,
  ) => {
    if (!extensionList || extensionList.length === 0) return;

    return (
      <>
        <div className="extensions-dropdown__subheader">
          <IDHFormattedMessage id="ws_extensions" defaultMessage="Extensions" />
        </div>
        {extensionList.map((extensionData) => {
          switch (extensionData.type) {
            case ExtensionTypeEnum.CreatorDatabaseSubmissionForm:
              return (
                <div
                  className="dropdown__menu-item"
                  onClick={() =>
                    openExtensions(
                      CreatorDatabaseConfigurationSection.SubmissionForm,
                    )
                  }
                  key={extensionData.uuid}
                >
                  <IDHFormattedMessage
                    id="ws_creator_submission_form"
                    defaultMessage="Creator Submission Form"
                  />
                </div>
              );
            case ExtensionTypeEnum.ApiConnection:
              return (
                <div
                  className="dropdown__menu-item"
                  onClick={() =>
                    openExtensions(
                      CreatorDatabaseConfigurationSection.InstagramAccountVerification,
                    )
                  }
                  key={extensionData.uuid}
                >
                  <IDHFormattedMessage
                    id="ws_instagram_account_verification"
                    defaultMessage="Instagram Account Verification"
                  />
                </div>
              );
            default:
              return null;
          }
        })}
      </>
    );
  };

  return (
    <DropdownPortal
      overlay={
        <DropdownMenu className="extensions-dropdown__menu" isOpen>
          {renderExtensionsListOptions(wsWorkspaceExtensions)}
        </DropdownMenu>
      }
      placement="bottomRight"
      onVisibleChange={(v: boolean) => setVisible(v)}
      visible={visible}
    >
      <span className="extensions-dropdown">
        <Button variant="white" size="small" textWithIcon>
          <LightningIcon />
          {numberOfEnabledWorkspaceExtensions.length}
        </Button>
      </span>
    </DropdownPortal>
  );
}
